module.exports = __webpack_public_path__ + "static/img/bg3.a9cebae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/bg3.jpg
// module id = AoA8
// module chunks = 0